/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckApplyRecognisedDocumentResponseError } from './PaxCheckApplyRecognisedDocumentResponseError';
import {
    PaxCheckApplyRecognisedDocumentResponseErrorFromJSON,
    PaxCheckApplyRecognisedDocumentResponseErrorFromJSONTyped,
    PaxCheckApplyRecognisedDocumentResponseErrorToJSON,
    PaxCheckApplyRecognisedDocumentResponseErrorToJSONTyped,
} from './PaxCheckApplyRecognisedDocumentResponseError';
import type { PaxCheckApplyRecognisedDocumentResult } from './PaxCheckApplyRecognisedDocumentResult';
import {
    PaxCheckApplyRecognisedDocumentResultFromJSON,
    PaxCheckApplyRecognisedDocumentResultFromJSONTyped,
    PaxCheckApplyRecognisedDocumentResultToJSON,
    PaxCheckApplyRecognisedDocumentResultToJSONTyped,
} from './PaxCheckApplyRecognisedDocumentResult';

/**
 * 
 * @export
 * @interface PaxCheckApplyRecognisedDocumentResponse
 */
export interface PaxCheckApplyRecognisedDocumentResponse {
    /**
     * 
     * @type {PaxCheckApplyRecognisedDocumentResult}
     * @memberof PaxCheckApplyRecognisedDocumentResponse
     */
    data?: PaxCheckApplyRecognisedDocumentResult;
    /**
     * 
     * @type {PaxCheckApplyRecognisedDocumentResponseError}
     * @memberof PaxCheckApplyRecognisedDocumentResponse
     */
    error?: PaxCheckApplyRecognisedDocumentResponseError;
}

/**
 * Check if a given object implements the PaxCheckApplyRecognisedDocumentResponse interface.
 */
export function instanceOfPaxCheckApplyRecognisedDocumentResponse(value: object): value is PaxCheckApplyRecognisedDocumentResponse {
    return true;
}

export function PaxCheckApplyRecognisedDocumentResponseFromJSON(json: any): PaxCheckApplyRecognisedDocumentResponse {
    return PaxCheckApplyRecognisedDocumentResponseFromJSONTyped(json, false);
}

export function PaxCheckApplyRecognisedDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckApplyRecognisedDocumentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PaxCheckApplyRecognisedDocumentResultFromJSON(json['data']),
        'error': json['error'] == null ? undefined : PaxCheckApplyRecognisedDocumentResponseErrorFromJSON(json['error']),
    };
}

export function PaxCheckApplyRecognisedDocumentResponseToJSON(json: any): PaxCheckApplyRecognisedDocumentResponse {
    return PaxCheckApplyRecognisedDocumentResponseToJSONTyped(json, false);
}

export function PaxCheckApplyRecognisedDocumentResponseToJSONTyped(value?: PaxCheckApplyRecognisedDocumentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PaxCheckApplyRecognisedDocumentResultToJSON(value['data']),
        'error': PaxCheckApplyRecognisedDocumentResponseErrorToJSON(value['error']),
    };
}

